import { render, staticRenderFns } from "./PoropostaAcrodo.vue?vue&type=template&id=ff1076f2"
import script from "./PoropostaAcrodo.vue?vue&type=script&lang=js"
export * from "./PoropostaAcrodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports